import React, { PureComponent } from 'react';
import { Form, Modal } from 'antd';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { withActions } from 'actionware';

import { toggleApplicationApprovalModal, approvalModalDetail, toggleAppDetail } from './applicationApprovalActions';
import ApplicationDetail from './applicationDetail';
import { getRole } from '../../common/helpers';

@connect(({ localize, applicationApproval: { showingApplicationApprovalModal, action: { modalType, bulk }, modalContent } }) => ({
  translate: getTranslate(localize),
  showingApplicationApprovalModal,
  modalType,
  bulk,
  modalContent
}))
@withActions({
  toggleApplicationApprovalModal,
  approvalModalDetail,
  toggleAppDetail
})
export default class AccountCreationModal extends PureComponent {
  constructor() {
    super();
    this.onCancel = this.onCancel.bind(this);
    this.onClickApprove = this.onClickApprove.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showingApplicationApprovalModal && !this.props.showingApplicationApprovalModal) {
      
    }
  }

  onClickApprove = (content, modalType = 'approve', bulk = false) => {
    this.props.approvalModalDetail(content)
    this.props.toggleAppDetail({modalType, bulk});
  };

  onCancel() {
    this.props.toggleApplicationApprovalModal();
  }

  render() {
    const {
      showingApplicationApprovalModal,
      translate,
      modalType,
      bulk,
      modalContent,
      role
    } = this.props;

    const title = {
      approve: translate('applicationApprovalModal.ovo_admin_heading_confirm_loan_approval'),
      reject: translate('applicationApprovalModal.ovo_admin_heading_confirm_loan_approval_rejection'),
      all: ''
    };

    return (
      <Modal
        className={'modal-form'}
        visible={showingApplicationApprovalModal}
        title={
          <div>
            <div className={'title'}>
              {title[modalType]}
            </div>
          </div>
        }
        onCancel={this.onCancel}
        width={630}
      >
        <ApplicationDetail
          detail={modalContent}
          bulk={bulk}
          modalType={modalType}
          onCancel={this.onCancel}
          onClickApprove={this.onClickApprove}
          role={role}
        />
      </Modal>
    );
  }
}
